<template>
  <div class="training">
    <div id="training" class="anchor"></div>
    <div class="enterprise-title">培训体系</div>
    <div class="training-content">
      <lr-link
        class="training-content-item"
        :to="item.url"
        v-for="(item, index) in training"
        :key="index"
        @click="reportClick(item.id)"
        target="_blank"
      >
        <img :src="trainingImg(item.img)" />
        <div class="training-content-item-text">
          <p v-text="item.title"></p>
          <span v-text="item.tips"></span>
        </div>
      </lr-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    training: {
      type: Array,
      default: () => [
        {
          title: '生产力系列',
          tips: '一站式全能办公',
          img: 'productivity',
          url: 'https://www.wps.cn/learning/article/simple/id/330387.html',
          id: '330387',
        }
      ],
    },
  },

  methods: {
    trainingImg(img) {
      return require(`@/assets/image/enterprise/training/${img}.png`);
    },
    reportClick(type) {
      this.$collect.enterpriseHomepageClick({ type, area: 'training' });
    },
  },
};
</script>
<style lang="scss" scoped>
.training {
  &-content {
    display: flex;
    justify-content: space-between;
    &-item {
      width: 356px;
      height: 150px;
      overflow: hidden;
      position: relative;
      > img {
        width: 100%;
        height: 100%;
        cursor: pointer;
        &:hover {
          transition: all 1s;
          transform: scale(1.1);
        }
      }
      &-text {
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translate(0, -50%);
        text-align: left;
        color: black;
        cursor: pointer;
        user-select: none;
        color: #ffffff;
        pointer-events: none;
        > p {
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 8px;
        }
        > span {
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
